module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-1000-Classes-Active-f0388a8a55c735aa6abf71e80b04fd15.png";